module.exports = "\t\n<app-navbar></app-navbar>\n<div class=\"width\"></div>\n<router-outlet></router-outlet>\n"